'use strict'

import { TimelineMax } from 'gsap';
import { CLASS_ACTIVE } from './helpers';

/**
 * Follow us related functionality.
 */
const followUs = {

  /**
   * Timeline object (https://greensock.com/docs/v3/GSAP/Timeline) for animations of this module 
   */
  timeline: new TimelineMax({
    paused: true
  }),

  /**
   * Dom related elements and variables
   */
  dom: {
    elements: {
      desktop: {
        alternatives: Array.from(document.querySelectorAll('.body-footer .follow-us .links li > *')).reverse(),
        wrapper: document.querySelector('.body-footer .follow-us')
      },
      mobile: {
        alternatives: Array.from(document.querySelectorAll('.mobile-menu .follow-us .links li > *')),
        wrapper: document.querySelector('.mobile-menu .follow-us')
      } 
    }
  },

  /**
   * Function on onMouseEnter event. Plays share animation.
   */
  onMouseEnter: function () {
    this.timeline.play();
  },

  /**
   * Function on onMouseLeave event. Reverses share animation.
   */
  onMouseLeave: function() {
    this.timeline.reverse();
  },

  /**
   * Function on onClick event. Plays or reverses animation based on timeline object's progress.
   */
  onClick: function () {
    if (this.timeline.progress() === 1) {
      this.timeline.reverse();
    } else {
      this.timeline.play();
    }
  },

  /**
   * Creates timeline for follow us animations.
   */
  createTimeline: function () {

    const onStart = () => {
      // Add active class when timeline starts
      this.dom.elements.desktop.wrapper.classList.add(CLASS_ACTIVE);
      this.dom.elements.mobile.wrapper.classList.add(CLASS_ACTIVE);
    };
    this.timeline.eventCallback('onStart', onStart);

    const onReverseComplete = () => {
      // Remove active class when timeline reverse is complete
      this.dom.elements.desktop.wrapper.classList.remove(CLASS_ACTIVE);
      this.dom.elements.mobile.wrapper.classList.remove(CLASS_ACTIVE);
    };
    this.timeline.eventCallback('onReverseComplete', onReverseComplete);

    // Show follow us alternatives
    this.timeline.fromTo([this.dom.elements.desktop.alternatives,this.dom.elements.mobile.alternatives],
      {
        opacity: 0,
        top: '20px'
      },
      {
        opacity: 1,
        top: '0px',
        ease: 'power4.out',
        duration: 0.3,
        stagger: 0.05
      }
    );
  },

  /**
   * Initializes module adds event listeners and creates animation timeline.
   */
  init: function () {

    this.createTimeline();

    // Mouse enter and leave listeners
    const onMouseEnter = this.onMouseEnter.bind(this);
    this.dom.elements.desktop.wrapper.addEventListener('mouseenter', onMouseEnter);

    const onMouseLeave = this.onMouseLeave.bind(this);
    this.dom.elements.desktop.wrapper.addEventListener('mouseleave', onMouseLeave);

    // Click listeners
    const onClick = this.onClick.bind(this);
    this.dom.elements.mobile.wrapper.addEventListener('click', onClick);
    this.dom.elements.desktop.wrapper.addEventListener('click', onClick);
  }
}

module.exports = followUs;